module.exports = __webpack_public_path__ + "media/assets/icons/link-d6f4f51bb5e4a7804ab6120a76405569.svg";